import ExpenseDetailComponent from '../../components/expenses/ExpenseDetailComponent';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import { useEffect, useState } from 'react';
import { Expense, createExpenseCommentAsync } from '../../modules/expenses';
import { Drawer } from 'antd';
import { saveAs } from 'file-saver';
import ExpenseEditDrawer from './ExpenseEditDrawer';
import CreateExpenseCommentModal from '../../components/expenses/CreateExpenseCommentModal';
import PDFViewModal2 from '../../components/expenses/PDFViewModal2';

interface ExpenseDetailDrawerProps {
  config: any;
  visible: boolean;
  onClose: () => void;
}

function ExpenseDetailDrawer({
  config,
  visible,
  onClose,
}: ExpenseDetailDrawerProps) {
  const [visibleEditlDrawer, setVisibleEditDrawer] = useState<boolean>(false);
  const [editDrawerConfig, setEditDrawerConfig] = useState<any>();
  const [visiblePdfView, setVisiblePdfView] = useState(false);
  const [visibleExpenseCreateModal, setVisibleExpenseCreateModal] =
    useState(false);
  const expenses = useSelector(
    (state: RootState) => state.expenses.expenses.data,
  );
  const [expense, setExpense] = useState<Expense>();
  const dispatch = useDispatch();
  useEffect(() => {
    if (expenses === null) return;
    if (config === null) return;
    setExpense(expenses.find((e) => e.id === +config.expenseId));
  }, [config, expenses]);

  const _downloadReceipt = () => {
    saveAs(
      expense?.file[0].url,
      `${expense?.usedDateTime}_${expense?.companyName}.pdf`,
    );
  };

  const moveToEditPage = () => {
    setEditDrawerConfig({ ...config });
    setVisibleEditDrawer(true);
  };

  const onCloseEditDrawer = () => {
    setVisibleEditDrawer(false);
  };

  const onOpenPdfView = () => setVisiblePdfView(true);
  const onClosePdfView = () => setVisiblePdfView(false);

  const onOpenCreateExpenseCommentModal = () =>
    setVisibleExpenseCreateModal(true);
  const onCloseCreateExpenseCommentModal = () =>
    setVisibleExpenseCreateModal(false);
  const onCreateExpenseComment = (value: any) => {
    dispatch(
      createExpenseCommentAsync.request({
        ...config,
        data: {
          ...value,
        },
      }),
    );
    setVisibleExpenseCreateModal(false);
  };

  return (
    <>
      {expense && (
        <Drawer
          width={800}
          placement="right"
          closable={false}
          onClose={onClose}
          open={visible}
        >
          {visible && (
            <ExpenseDetailComponent
              expense={expense}
              moveToEditPage={moveToEditPage}
              onOpenPdfView={onOpenPdfView}
              onOpenCreateExpenseCommentModal={onOpenCreateExpenseCommentModal}
            />
          )}
        </Drawer>
      )}
      {editDrawerConfig && expense && (
        <ExpenseEditDrawer
          config={editDrawerConfig}
          expense={expense}
          visible={visibleEditlDrawer}
          onClose={onCloseEditDrawer}
        />
      )}
      {visiblePdfView && expense && (
        <PDFViewModal2
          visible={visiblePdfView}
          url={expense.file[0].url}
          onCancel={onClosePdfView}
          onDownload={_downloadReceipt}
        />
      )}
      {visibleExpenseCreateModal && (
        <CreateExpenseCommentModal
          visible={visibleExpenseCreateModal}
          onCreate={onCreateExpenseComment}
          onCancel={onCloseCreateExpenseCommentModal}
        />
      )}
    </>
  );
}

export default ExpenseDetailDrawer;
